export const ELEMENTS_CHANNEL = 'fabric-elements';